module.exports = __webpack_public_path__ + "media/thumbnails/headgear-style-3-fd28802e.svg";